import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { uri } from '@bo-client/shared/constants/uri';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { ConfirmFeederContractModel } from '@bo-client/activation-management/feeder-contract/model/feeder-contract.model';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { GridRegistrationTypeEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-gr-place-in-service-confirmation',
  templateUrl: './gr-place-in-service-confirmation.component.html',
  styleUrls: ['./gr-place-in-service-confirmation.component.scss']
})
export class GrPlaceInServiceConfirmationComponent
  extends ConfirmationRequestPageBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @ViewChild('form')
  public form: RequestFormBase<GridRegistrationModel>;
  public uriGetData = uri.cmGridRegistrationRequestExternal;
  public requestApprovalDto: RequestApprovalDto;
  public compUnsubs$ = new Subject<void>();
  public actions = this.gridRegistrationRequestService.actions;
  readonly gridRegistrationTypeEnum = GridRegistrationTypeEnum;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    protected gridRegistrationRequestService: GridRegistrationRequestService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Inbetriebsetzung bestätigen';
  }

  ngOnInit() {
    super.init();
  }

  hookDataLoaded() {}

  hookGetDataFromForm() {
    this.requestApprovalDto.additionalData = this.requestApprovalDto
      .additionalData as ConfirmFeederContractModel;
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
